// AUTO-GENERATED by scripts/drive/sync-testimonials.py (video phase) - do not edit by hand.
// Mirrors Google Drive "Website Social Proof/Video Testimonials" ->
// TESTIMONIAL_VIDEO_ENTRIES. Review-everything law extended to video (owner
// interview 2026-07-23, context/marketing-master.md § 26): a video appears
// here only after the owner approves its /admin/decisions video_blur_review
// card. Before approval, the client's face is face-tracked and blurred for
// the whole clip (an organic outline, never a box) while the audio stays
// untouched; on approval the already-blurred clip is uploaded to Mux with a
// PUBLIC playback policy (this is a public marketing page, not the signed
// paid-course vault) and its playback id lands here.
export type TestimonialVideoEntry = {
  /** Stable id derived from the source filename. */
  id: string
  /** Human-readable title - the source filename, cleaned. */
  title: string
  /** Mux playback id (public policy) for the approved, already-blurred video. */
  playbackId: string
}

export const TESTIMONIAL_VIDEO_ENTRIES: TestimonialVideoEntry[] = [
  { id: "video-testimonial-client-at-home", title: "Video testimonial client at home", playbackId: "TkZcAldyAfJOhUr00ubTuLcyTnpJJLg00iKE7HEhSUSq4" },
  { id: "video-testimonial-client-feedback", title: "Video testimonial client feedback", playbackId: "2kfnni5Al2okDc1WY4K6zmNEd7PWI015osO66Eva6tEo" },
  { id: "video-testimonial-driving-car", title: "Video testimonial driving car", playbackId: "suisiRZe7Io76bBqMRfqkpl9ULlkHugJjcKYIvp6uhw" }
]
